export const siteSettings = {
  name: "Market Pulse Pro",
  link: "https://marketpulsepro.live",
  email: "support@marketpulsepro.live",
  appLink: "https://dashboard.marketpulsepro.live",
};
